import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import {AssistanceTicket} from '../../../../models/assistanceticket';
import { ConfService } from '../../../../services/conf.service';
import { ApiService } from '../../../../api/api.service';
import { DistancecalculService } from '../../../../services/distancecalcul.service';
import { TranslateService } from '@ngx-translate/core';
import { IamService } from '../../../../services/iam.service';


import * as _ from 'lodash';
import { MessageService } from 'primeng/api';
@Component({
    selector: 'app-assistance-reassign-provider',
    templateUrl: './assistance-reassign-provider.component.html',
    styleUrls: ['./assistance-reassign-provider.component.css'],
    standalone: false
})
export class AssistanceReassignProviderComponent implements OnInit {
  


  @Input() service : EventEmitter<number>;
  @Input() case_id: number;
  @Input() providers : EventEmitter<any>;
  @Input() sds_provider : EventEmitter<boolean>;
  // @Input() product;
  // @Input() Ticket: EventEmitter<AssistanceTicket>;
  country_id = 1
  service_id = 1
  providers_ 
  Provider_new 
  // sites: any[] = [];
  selectedRow:number
  selectedRowSite: any;
  setClickedRow: Function;
  setClickedRowSite: Function;
  // selectedProvider
  reassignInBuca =false
  editticket: AssistanceTicket;

  assistancePlanService:any;
   
  filter: any = {
    id:null
  }
  constructor( public conf: ConfService,
    private api: ApiService, private distapi: DistancecalculService,
    private translate: TranslateService,
    public messageService: MessageService,
   
    private iam: IamService) {

     }
  ngOnInit() {


    
    
    this.messageService.clear();
    this.service.subscribe(data=>{
      this.service_id = data
      
    
    

    })

  

    this.providers.subscribe(data=>{
      this.providers_ = data
    })

    // if(this.product["assistance_code"] == "BUCA01"){ this.reassignInBuca = true }

    // // this.setClickedRow = function(evt) {
    // //   this.selectedRow = evt.target.value;
    // //   
    // //   this.onSetSite()

    // // };
    this.setClickedRowSite = function(index, site){
      this.selectedRowSite = site;
      this.selectedRow = index
      this.selectedRowSite["case_id"] = this.editticket.case_id
      // this.selectedrowsite = site[1].id
      // 
      // 

    }
    // this.Ticket.subscribe(data => {
    //   this.editticket = Object.assign({}, data.Ticket);
    // })
    this.getPlanService(this.editticket.service.id, this.editticket.Case.plan.id)
    
  }

  // setClickRow(){
  //   if(this.reassignInBuca){
  //     for (let prov of this.providers_){
  //       if(prov.id == this.Provider_new){
  //         this.selectedProvider = prov
  //         this.onSetSite()
  //         break
  //       }
  //     }
  //   }
  // }

  // onSetSite() {
  //   if (this.selectedProvider.users) {
  //     this.sites = this.selectedProvider.users
  //   }
  // }

  Generar(){
    
    
    
    



    const filter = Object.assign({}, this.filter);
    filter['case_id']= this.case_id
    filter['Provider_new']= this.Provider_new.provider_id
    filter['Provider_site_new']= this.Provider_new.provider_site_id
    filter['Provider_coverage_new']= this.Provider_new.coverage_id


 
    this.api.assistancecases.reassignprovider().filter(filter).promise()
    .then(users => {
     
     
     window.location.reload()
    
     
   }) .catch(e => {

   
   
     
           
      });
      
     if(this.reassignInBuca){
      
      this.api.buca.reassignBucaCase(this.selectedRowSite).promise()
      .then(users => {
        this.messageService.add({severity: 'success', summary: 'Created', detail: "Reasignación en Buca realizada correctamente"});
      
      
      
      
    }) .catch(e => {
      this.messageService.add({severity: 'error', summary: 'Error', detail: "Reasignación en Buca no fue realizada"});
    
    
      
            
        });
    }

  }
  async getPlanService(service_id,plan_id){
   
   try{

    const filter = {'plan_id': plan_id,'service_id': service_id };

    await( this.api.assistanceplanservices.get_extrainfo().filter(filter).promise()
    .then(data => {
      this.assistancePlanService = data[0]
      if(this.sds_provider && this.editticket.service && this.assistancePlanService && this.assistancePlanService?.buca_apply == 1 ){ this.reassignInBuca = true }
    }))

   } catch(exception){
   }
  }

  

}
